export default [
  {
    image: `https://t4.ftcdn.net/jpg/06/60/61/49/240_F_660614962_3YXIQDkpdS8QTRi05DhAXqOnpXsj3VAb.jpg`,
    name: "BioTech",
    route: "#",
  },
  {
    image: `https://t3.ftcdn.net/jpg/07/28/56/34/240_F_728563459_bCFgYVzg2LdEUxJSoCBKt6meZsMOqPSO.jpg`,
    name: "Technology",
    route: "#",
  },
  {
    image:`https://t3.ftcdn.net/jpg/08/46/83/16/240_F_846831649_S8FinoviDnG4NgrOnPDy1nKOkgnbfyiI.jpg  `,
    name: "Machine Learning",
    route: "#",
  },
  {
    image: `https://t4.ftcdn.net/jpg/08/47/50/21/240_F_847502176_niiXEkYdGObnU7d94IbAiYuNM2oAYfNl.jpg`,
    name: "Medicine",
    route: "#",
  },
];
